/**
 * Income / rent verification rows from tenant-report-fullscreen.html.
 * Holders and bank names are applied per Carter applicant in overlay-html-sample.
 */
export type SampleTxn = {
	date: string
	amount: number
	category: string
	description: string
}

export const GOOD_INCOME_TXNS: SampleTxn[] = [
	{
		date: '2026-09-03',
		amount: 17,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-08-13',
		amount: 287,
		category: 'verified_income',
		description: "BOSCO & ROXY'S PAY",
	},
	{
		date: '2026-07-30',
		amount: 757,
		category: 'verified_income',
		description: "BOSCO & ROXY'S PAY",
	},
	{
		date: '2026-07-27',
		amount: 535,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-07-24',
		amount: 172,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-07-10',
		amount: 376,
		category: 'verified_income',
		description: '1001567944 ONTA PAY',
	},
	{
		date: '2026-07-10',
		amount: 14,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-07-10',
		amount: 272,
		category: 'govt_benefits',
		description: 'CAN WRKS BEN CWB',
	},
	{
		date: '2026-07-10',
		amount: 378,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2026-06-29',
		amount: 10,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2026-06-26',
		amount: 838,
		category: 'verified_income',
		description: '1001567944 ONTA PAY',
	},
	{
		date: '2026-06-26',
		amount: 105,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-06-20',
		amount: 538,
		category: 'potential_income',
		description: 'DEPOSIT MB-DEP',
	},
	{
		date: '2026-06-12',
		amount: 787,
		category: 'verified_income',
		description: '1001567944 ONTA PAY',
	},
	{
		date: '2026-06-12',
		amount: 212,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-06-10',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2026-06-05',
		amount: 267,
		category: 'govt_benefits',
		description: 'GST GST',
	},
	{
		date: '2026-06-05',
		amount: 355,
		category: 'potential_income',
		description: 'DEPOSIT MB-DEP',
	},
	{
		date: '2026-05-29',
		amount: 770,
		category: 'verified_income',
		description: '1001567944 ONTA PAY',
	},
	{
		date: '2026-05-29',
		amount: 392,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-05-23',
		amount: 747,
		category: 'potential_income',
		description: 'DEPOSIT MB-DEP',
	},
	{
		date: '2026-05-15',
		amount: 528,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-05-15',
		amount: 203,
		category: 'verified_income',
		description: '1001567944 ONTA PAY',
	},
	{
		date: '2026-05-08',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2026-05-01',
		amount: 716,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-04-27',
		amount: 14,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2026-04-20',
		amount: 16,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-04-20',
		amount: 12,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2026-04-20',
		amount: 18,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-04-20',
		amount: 20,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2026-04-17',
		amount: 769,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-04-10',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2026-04-02',
		amount: 1034,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-04-02',
		amount: 133,
		category: 'govt_benefits',
		description: 'GST GST',
	},
	{
		date: '2026-03-27',
		amount: 11,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2026-03-23',
		amount: 17,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-03-20',
		amount: 736,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-03-19',
		amount: 2140,
		category: 'govt_benefits',
		description: 'TAX REFUND RIT',
	},
	{
		date: '2026-03-10',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2026-03-06',
		amount: 743,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-03-02',
		amount: 24,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2026-02-23',
		amount: 24,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-02-23',
		amount: 18,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2026-02-20',
		amount: 782,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-02-09',
		amount: 8,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2026-02-06',
		amount: 746,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-02-06',
		amount: 9,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2026-01-23',
		amount: 867,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-01-19',
		amount: 8,
		category: 'side_gig',
		description: 'UBER * PENDING _V',
	},
	{
		date: '2026-01-19',
		amount: 19,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2026-01-12',
		amount: 265,
		category: 'govt_benefits',
		description: 'CAN WRKS BEN CWB',
	},
	{
		date: '2026-01-12',
		amount: 8,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2026-01-09',
		amount: 627,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2026-01-05',
		amount: 133,
		category: 'govt_benefits',
		description: 'GST GST',
	},
	{
		date: '2025-12-24',
		amount: 568,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-12-22',
		amount: 22,
		category: 'side_gig',
		description: 'LYFT PAYOUT _V',
	},
	{
		date: '2025-12-15',
		amount: 20,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2025-12-12',
		amount: 967,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-11-28',
		amount: 1072,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-11-28',
		amount: 16,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2025-11-14',
		amount: 668,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-11-10',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2025-10-31',
		amount: 696,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-10-23',
		amount: 16,
		category: 'side_gig',
		description: 'DOORDASH DASHER _V',
	},
	{
		date: '2025-10-17',
		amount: 357,
		category: 'verified_income',
		description: 'COMMISSIONAIRES PAY',
	},
	{
		date: '2025-10-14',
		amount: 18,
		category: 'side_gig',
		description: 'UBER CANADA/UBE _V',
	},
	{
		date: '2025-10-10',
		amount: 265,
		category: 'govt_benefits',
		description: 'CAN WRKS BEN CWB',
	},
	{
		date: '2025-10-10',
		amount: 31,
		category: 'govt_benefits',
		description: 'CANADA PRO',
	},
	{
		date: '2025-10-03',
		amount: 133,
		category: 'govt_benefits',
		description: 'GST GST',
	},
	{
		date: '2025-09-25',
		amount: 11843,
		category: 'govt_benefits',
		description: 'CANADA LIFE INS',
	},
]

export const BAD_INCOME_TXNS: SampleTxn[] = [
	{
		date: '2026-08-31',
		amount: 1050,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-07-31',
		amount: 1050,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-07-14',
		amount: 690,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-06-30',
		amount: 360,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-05-29',
		amount: 1050,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-04-30',
		amount: 1050,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-04-08',
		amount: 1380,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-03-31',
		amount: 360,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
	{
		date: '2026-03-31',
		amount: 58,
		category: 'govt_benefits',
		description: 'TORONTO OW PAY',
	},
]

export const GUARANTOR_INCOME_TXNS: SampleTxn[] = [
	{
		date: '2026-08-31',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-08-14',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-07-31',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-07-15',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-06-30',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-06-15',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-05-29',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-05-15',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-04-30',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-04-15',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-03-31',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-03-13',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-02-27',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-02-13',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-01-30',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2026-01-15',
		amount: 1507,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-12-31',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-12-15',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-11-28',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-11-14',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-10-31',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-10-15',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-09-29',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
	{
		date: '2025-09-15',
		amount: 1472,
		category: 'verified_income',
		description: 'PAIE/PAYROLL PAY/PAY',
	},
]

export const GOOD_RENT_TXNS: SampleTxn[] = [
	{
		date: '2026-08-04',
		amount: 573,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-07-30',
		amount: 950,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-07-13',
		amount: 724,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-07-07',
		amount: 850,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-06-15',
		amount: 800,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-06-08',
		amount: 775,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-05-19',
		amount: 550,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-05-08',
		amount: 600,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-04-01',
		amount: 1523,
		category: 'rent_verified',
		description: 'Sifton Prop AP',
	},
	{
		date: '2026-03-24',
		amount: 416,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-03-20',
		amount: 900,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-03-19',
		amount: 850,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-02-27',
		amount: 950,
		category: 'rent_verified',
		description: 'SIFTON PROPERTI',
	},
	{
		date: '2026-01-02',
		amount: 1492,
		category: 'rent_verified',
		description: 'Sifton Prop AP',
	},
	{
		date: '2025-12-01',
		amount: 1492,
		category: 'rent_verified',
		description: 'Sifton Prop AP',
	},
	{
		date: '2025-11-03',
		amount: 1492,
		category: 'rent_verified',
		description: 'Sifton Prop AP',
	},
	{
		date: '2025-10-01',
		amount: 1492,
		category: 'rent_verified',
		description: 'Sifton Prop AP',
	},
]

export const BAD_RENT_TXNS: SampleTxn[] = []

export const GUARANTOR_RENT_TXNS: SampleTxn[] = [
	{
		date: '2026-08-31',
		amount: 1000,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20262431750KQP4RD',
	},
	{
		date: '2026-08-06',
		amount: 1000,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20262181833M2HXVA',
	},
	{
		date: '2026-07-31',
		amount: 1000,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 202621208444TNZ8B',
	},
	{
		date: '2026-07-02',
		amount: 1013,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20261821036PWQ7EJ',
	},
	{
		date: '2026-06-04',
		amount: 2000,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20261551115RBKT3Y',
	},
	{
		date: '2026-04-27',
		amount: 2000,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20261172246DLF9QN',
	},
	{
		date: '2026-04-02',
		amount: 1026,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 20260922259XHGZCM',
	},
	{
		date: '2026-03-30',
		amount: 1022,
		category: 'potential_rent',
		description: 'INTERAC ETRNSFR SENT ANNA MORRIS 202608922517JVNQR',
	},
]
